import type React from 'react';
import { Box, Flex, Grid, RiFileHistoryLine } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import clsx from 'clsx';
import Styles from './EstimationHistoryNavigation.module.scss';
import type { DealEstimationHeader } from '~/models/DealEstimationHeader';
import { formatDate } from '~/utils/DateUtil';
import { toThousandSeparator } from '~/utils/CurrencySeparator';

type Props = {
  detailPagePath: (headerId: number) => string;
  dealEstimationHeaders: DealEstimationHeader[];
  ownManagement?: boolean;
};

export const EstimationHistoryNavigation: React.FC<Props> = ({
  detailPagePath,
  dealEstimationHeaders,
  ownManagement = false
}: Props) => {
  if (dealEstimationHeaders?.length === 0) return null;
  return (
    <div className={Styles.NavigationBlock}>
      <div className={Styles.IconWrapper}>
        <RiFileHistoryLine className={Styles.Icon} />
      </div>
      <Box marginBottom=".5rem" width="100%">
        <h1 className={Styles.Title}>
          {`${!ownManagement ? '提出された' : ''}工事見積書一覧`}
        </h1>
        {dealEstimationHeaders.map(
          (dealEstimationHeader: DealEstimationHeader) => (
            <Flex
              key={dealEstimationHeader.id}
              alignItems="center"
              marginBottom=".5rem"
              marginTop={ownManagement ? '0' : '.5rem'}
            >
              <Flex direction="column" gap=".25rem">
                {!ownManagement && (
                  <div>
                    提出日：{formatDate(dealEstimationHeader.requestedAt, true)}{' '}
                    提出者：
                    {dealEstimationHeader.staffName
                      ? dealEstimationHeader.staffName
                      : dealEstimationHeader.vendorUserName}
                  </div>
                )}
                <div className={clsx(!ownManagement && Styles.SubText)}>
                  見積り件数：{dealEstimationHeader.count}件 合計金額： ¥
                  {toThousandSeparator(
                    dealEstimationHeader.confirmedTotalAmountWithTax
                  )}
                  (税込)
                </div>
              </Flex>
              <Grid marginLeft="auto">
                <Link
                  className={Styles.DetailLink}
                  href={detailPagePath(dealEstimationHeader.id)}
                >
                  詳細確認
                </Link>
              </Grid>
            </Flex>
          )
        )}
      </Box>
    </div>
  );
};
